import React from 'react'
import { mergeProps } from 'src/util'
import styles from './SidebarSeparator.scss'

/**
 * A separator for the Sidebar.
 */
const SidebarSeparator = ({ ...domProps }) => <div {...mergeProps()({ className: styles.separator }, domProps)} />

export default SidebarSeparator
